import React from 'react'
import './Number.css'

function Number({icon, number, info}) {
    return (
        <div className="number">
            <div className="number__icon">
                {icon}
            </div>
            <div className="number__info">
                <h3>{number}</h3>
                <p>{info}</p>
            </div>
        </div>
    )
}

export default Number
